import { createAction } from 'Lib/reduxUtils';

import { LOAD_LANGUAGE, LOAD_LANGUAGE_SUCCESS } from './constants';

export const loadLanguage = createAction(LOAD_LANGUAGE, (language: string) => language);
export const loadLanguageSuccess = createAction(
  LOAD_LANGUAGE_SUCCESS,
  (language: string) => language
);
